import apiClient from '../axios.js';

export const questionnaireService = {
  list: (params = {}) => apiClient.get('/admin/questionnaires', { params }),
  get: (id) => apiClient.get(`/admin/questionnaires/${id}`),
  create: (payload) => apiClient.post('/admin/questionnaires', payload),
  update: (id, payload) => apiClient.put(`/admin/questionnaires/${id}`, payload),
  publish: (id) => apiClient.post(`/admin/questionnaires/${id}/publish`),
  end: (id) => apiClient.post(`/admin/questionnaires/${id}/end`),
  republish: (id) => apiClient.post(`/admin/questionnaires/${id}/republish`),
  copy: (id, payload = {}) => apiClient.post(`/admin/questionnaires/${id}/copy`, payload),
  remove: (id) => apiClient.delete(`/admin/questionnaires/${id}`),
  responses: (id, params = {}) => apiClient.get(`/admin/questionnaires/${id}/responses`, { params }),
  clearResponses: (id) => apiClient.post(`/admin/questionnaires/${id}/responses/clear`),
  stats: (id) => apiClient.get(`/admin/questionnaires/${id}/stats`)
};
